import { useShallow } from 'zustand/react/shallow';
import { useCanvasStore } from '../store';

/**
 * Returns current zoom value of the canvas
 */
export const useCanvasZoom = () => {
  const zoomLevels = useCanvasStore(
    useShallow((state) => ({
      canvasNativeZoomLevel: state.canvasNativeZoomLevel,
      zoomDisplayValue: state.zoomDisplayValue,
    })),
  );

  return zoomLevels;
};
